import { render, staticRenderFns } from "./ReportEnrollmentsByOma.vue?vue&type=template&id=7e213496&scoped=true"
import script from "./ReportEnrollmentsByOma.vue?vue&type=script&lang=js"
export * from "./ReportEnrollmentsByOma.vue?vue&type=script&lang=js"
import style0 from "./ReportEnrollmentsByOma.vue?vue&type=style&index=0&id=7e213496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e213496",
  null
  
)

export default component.exports